import { z } from 'zod';

// TimeValue validation helper
const timeValueSchema = z.object({
    hour: z.number().int().min(0).max(23),
    minute: z.number().int().min(0).max(59),
});
// Hours validation schema
const hoursSchema = z
    .record(z.string(), z
    .object({
    isOpen: z.boolean(),
    openTime: timeValueSchema,
    closeTime: timeValueSchema,
})
    .nullable())
    .refine((value) => {
    if (!value || typeof value !== 'object') {
        return false;
    }
    const days = Object.keys(value);
    return days.length > 0;
}, { message: 'At least one day must have hours set' })
    .refine((value) => {
    if (!value || typeof value !== 'object') {
        return false;
    }
    let hasOpenDay = false;
    for (const day of Object.keys(value)) {
        const dayData = value[day];
        if (!dayData || typeof dayData !== 'object') {
            continue;
        }
        const { isOpen, openTime, closeTime } = dayData;
        // If day is marked as open, both times must be provided
        if (isOpen === true) {
            hasOpenDay = true;
            // Check if openTime is a valid TimeValue object
            if (!openTime || typeof openTime !== 'object' || !('hour' in openTime)) {
                return false;
            }
            // Check if closeTime is a valid TimeValue object
            if (!closeTime || typeof closeTime !== 'object' || !('hour' in closeTime)) {
                return false;
            }
        }
    }
    return hasOpenDay;
}, { message: 'At least one day must be marked as open with valid hours' })
    .superRefine((value, ctx) => {
    if (!value || typeof value !== 'object') {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'Support hours are required',
        });
        return;
    }
    for (const day of Object.keys(value)) {
        const dayData = value[day];
        if (!dayData || typeof dayData !== 'object') {
            continue;
        }
        const { isOpen, openTime, closeTime } = dayData;
        // If day is marked as open, both times must be provided
        if (isOpen === true) {
            // Check if openTime is a valid TimeValue object
            if (!openTime || typeof openTime !== 'object' || !('hour' in openTime)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: `${day} must have a valid opening time`,
                    path: [day, 'openTime'],
                });
            }
            // Check if closeTime is a valid TimeValue object
            if (!closeTime || typeof closeTime !== 'object' || !('hour' in closeTime)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: `${day} must have a valid closing time`,
                    path: [day, 'closeTime'],
                });
            }
        }
    }
});

export { hoursSchema };
//# sourceMappingURL=hours.js.map
